import React, { useEffect, useState } from "react";

import { Modal, Typography } from "@packages/ds";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";

import * as S from "./ProjectInvitationWaitingScreen.styles";

const MAX_TRY_NUMBER = 5;

const ProjectInvitationWaitingScreen = () => {
  const [count, setCount] = useState(0);
  const [error, setError] = useState(false);
  const { projectId } = useDecodedParams<{ projectId: string }>();

  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    let isCanceled = false;
    const timeout = setTimeout(async () => {
      const platformLib = await import("Libs/platform");
      const client = platformLib.default;

      try {
        await client.getProject(projectId);

        navigate(`/invitation/${projectId}`);
      } catch {
        if (isCanceled) {
          return;
        }
        if (count < MAX_TRY_NUMBER) {
          setCount(count + 1);
        } else {
          setError(true);
        }
      }
    }, count && 5000);

    return () => {
      isCanceled = true;
      clearTimeout(timeout);
    };
  }, [count, navigate, projectId]);

  const onClose = () => navigate("/");

  return (
    <Modal
      isOpen={true}
      size="medium"
      onOpenChange={onClose}
      handleClose={onClose}
    >
      <Typography.Title tag="h3">
        {intl.formatMessage({ id: "invitation.pending" })}
      </Typography.Title>
      <S.Message>
        {error ? (
          <FormattedMessage id="invitation.pendingFail" />
        ) : (
          <FormattedMessage id="invitation.pendingLoading" />
        )}
      </S.Message>
    </Modal>
  );
};

export default ProjectInvitationWaitingScreen;
